
import React, {useState} from "react";
import "../../sass/components/CheckboxDropdown.scss";
import { Button, Dropdown, Form } from "react-bootstrap";
import i18n from "i18next";

const CheckboxMenu = React.forwardRef(
    (
        {
            children,
            style,
            className,
            "aria-labelledby": labeledBy
        },
        ref
    ) => {
        return (
            <div
                ref={ref}
                style={style}
                className={`${className} CheckboxMenu`}
                aria-labelledby={labeledBy}
            >
                <div
                    className="d-flex flex-column"
                    style={{ maxHeight: "calc(100vh)", overflow: "none" }}
                >
                    <ul
                        className="list-unstyled flex-shrink"
                        style={{ overflow: "auto" }}
                    >
                        {children}
                    </ul>
                </div>
            </div>
        );
    }
);

const CheckDropdownItem = React.forwardRef(
    ({ children, id, checked, onChange }, ref) => {
        return (
            <Form.Group ref={ref} className="dropdown-item" controlId={id}>
                <Form.Check
                    type="checkbox"
                    label={children}
                    checked={checked}
                    onChange={onChange && onChange.bind(onChange, id)}
                />
            </Form.Group>
        );
    }
);

export const CheckboxDropdown = (({ items, label, setItems, dataTestid }) => {
    const [toggle, setToggle] = useState(false);
    const [clickable, setClickable] = useState(false);

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <Button onClick={(e) => {
            e.preventDefault();
            setToggle(!toggle);
            setClickable(!clickable);
            onClick(e);
        }} id="dropdown-basic" data-testid={dataTestid+"_button"}>
            <span data-testid={dataTestid+"_span"}>{label}</span>
            {!toggle ?
                <i className="fas fa-chevron-down" /> :
                <i className="fas fa-chevron-up" />}
        </Button>
    ))

    const handleChecked = (key, event) => {
        setItems(
            items.map((item) => {
                if (item.id === key) {
                    // If the item is a module, don't apply translation, use the module name as the label
                    const label = item.id.startsWith("module-") 
                        ? item.label // Use the module's name directly
                        : i18n.t("filter-slider." + key.toLowerCase().replaceAll(' ', '-')); // Apply translation for non-module filters
    
                    return {
                        id: key, 
                        label: label, 
                        checked: event.target.checked
                    };
                }
                return item;
            })
        );
    };

    return (
        <div>
            <Dropdown onClick={() => setClickable(!clickable)} onToggle={() => setToggle(!toggle)}>
                <Dropdown.Toggle as={CustomToggle} variant="primary" id="dropdown-basic" />

                <Dropdown.Menu
                    as={CheckboxMenu}
                >
                    {items.map(i => (
                        <Dropdown.Item
                            key={i.id}
                            as={CheckDropdownItem}
                            id={i.id}
                            checked={i.checked}
                            onChange={handleChecked}
                        >
                            {i.label}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
});
